import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const VENDORS_LIST = "vendors_list";
export const CREATE_VENDORS = "create_vendors";
export const UPDATE_VENDORS = "update_vendors";
export const DELETE_VENDORS = "delete_vendors";
export const GET_VENDORS_DETAILS = "get_vendors_details";
export const VENDORS_SIMPLE_LIST = "vendors_simple_list";
export const VENDORS_SIMPLE_FULL_LIST = "vendors_simple_full_list";
export const CLEAR_VENDORS_ERRORS = "clearVendorsErrors";

// mutation types
export const SET_VENDORS_ERROR = "setVendorsErrors";
export const REMOVE_VENDORS_ERRORS = "removeVendorsErrors";

const state = {
    errors: null
};
const actions = {
    [VENDORS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/vendors?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_VENDORS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_VENDORS_ERROR, response.errors);
                });
        });
    },
    [CREATE_VENDORS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createvendor", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_VENDORS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_VENDORS_ERROR, response.errors);
                });
        });
    },
    [UPDATE_VENDORS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatevendor", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_VENDORS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_VENDORS_ERROR, response.errors);
                });
        });
    },
    [DELETE_VENDORS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletevendor", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_VENDORS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_VENDORS_ERROR, response.errors);
                });
        });
    },
    [GET_VENDORS_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getvendordetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_VENDORS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_VENDORS_ERROR, response.errors);
                });
        });
    },
    [CLEAR_VENDORS_ERRORS](context) {
        context.commit(REMOVE_VENDORS_ERRORS);
    },
    [VENDORS_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/vendorssimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
    [VENDORS_SIMPLE_FULL_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/vendorssimplefull")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
};

const mutations = {
    [SET_VENDORS_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_VENDORS_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
